import {ChangeDetectionStrategy, Component, computed, inject} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import {Store} from '@ngrx/store';
import {getColorForName} from 'src/app/shared/utils/name-to-color.util';
import {OphBackButtonComponent} from 'src/app/shared/design/oph-back-button/oph-back-button.component';
import {ChallengeMetricUomDisplayPipe} from 'src/app/shared/pipes/challenge-metric-uom-display.pipe';
import {TrackerMetricValuePipe} from 'src/app/shared/pipes/tracker-metric-value.pipe';
import {PipesModule} from 'src/app/shared/pipes/pipes.module';
import {selectChartDetailFor, selectChartDetailLoadingFor} from 'src/app/core/store/current-sked/current-sked.selector';
import {CsChartDetailDialogHeaderComponent} from 'src/app/current-sked/challenge/shared/cs-chart-detail-dialog-header/cs-chart-detail-dialog-header.component';

export interface CsDayChartDetailDialogData {
  projectId: string;
  metricId: string;
  timestamp: string;
  dateKey: string;
}

@Component({
  selector: 'cs-day-chart-detail-dialog',
  standalone: true,
  imports: [
    MatProgressSpinnerModule,
    OphBackButtonComponent,
    ChallengeMetricUomDisplayPipe,
    TrackerMetricValuePipe,
    PipesModule,
    CsChartDetailDialogHeaderComponent,
  ],
  templateUrl: 'cs-day-chart-detail-dialog.component.html',
  styleUrl: './cs-day-chart-detail-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CsDayChartDetailDialogComponent {
  private readonly store = inject(Store);
  readonly dialogRef = inject(MatDialogRef<CsDayChartDetailDialogComponent>);
  readonly data = inject<CsDayChartDetailDialogData>(MAT_DIALOG_DATA);

  readonly chartDetail = this.store.selectSignal(selectChartDetailFor(this.data.dateKey, this.data.metricId));
  readonly chartDetailLoading = this.store.selectSignal(
    selectChartDetailLoadingFor(this.data.dateKey, this.data.metricId)
  );
  readonly isComplete = computed(() => {
    const detail = this.chartDetail();
    return detail ? detail.currentValue >= detail.targetValue : false;
  });

  percentComplete = (): number => {
    const detail = this.chartDetail();
    if (!detail || detail.targetValue <= 0) return 0;
    return Math.min(Math.round((detail.currentValue / detail.targetValue) * 100), 100);
  };

  getChartProgressColor(chartName: string): string {
    return getColorForName(chartName, 'metric');
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
